import { CreatePromoCode, PaymentSystems, ProxyPrices, TablePromoCode, TabsNavigate } from "./components";
import style from "./SettingsPage.module.scss";
import { useSearchParams } from "react-router-dom";

export function SettingsPage() {
  const [queryParams] = useSearchParams();

  return (
    <main className={style.page}>
      <TabsNavigate />
      {
        queryParams.get("tab") === "promo_codes"
          ? <>
            <CreatePromoCode />
            <TablePromoCode />
          </>
          : null 
      }
      {
        queryParams.get("tab") === "payment_systems"
          ? <PaymentSystems />
          : null
      }
      {
        queryParams.get("tab") === "proxy_prices"
          ? <ProxyPrices />
          : null
      } 
    </main>
  );
}
